import { DimensionUnit } from '@freight-cbm/shared-types';
import { convertToMeters } from './units';

export function computeCBM(
  length: number,
  width: number,
  height: number,
  dimUnit: DimensionUnit,
  quantity: number,
): number {
  const l = convertToMeters(length, dimUnit);
  const w = convertToMeters(width, dimUnit);
  const h = convertToMeters(height, dimUnit);

  if (isNaN(l) || isNaN(w) || isNaN(h)) return NaN;

  const cbmPerPiece = l * w * h;
  return cbmPerPiece * quantity;
}
